import axios from "axios";

export const state = {
    canteenattendants: [],
};

export const getters = {
    canteenattendants: state => state.canteenattendants,
};

export const mutations = {
    setCanteenUsers(state, newValue) {
        state.canteenattendants = newValue
    },
};

export const actions = {
    fetchCanteenUsers({ commit }) {
        axios.get('/canteenattendants').then(res => {
            commit('setCanteens', res.data.canteenattendants);
        })
    },
};
